/* eslint-disable import/no-extraneous-dependencies */
import { useState } from 'react';
import SecureLS from 'secure-ls';

const secureLS = new SecureLS({ isCompression: false });

export const useLocalStorage = (keyName, defaultValue) => {
  const setEncryptedValue = (value) => {
    try {
      // Store the value directly without stringifying
      secureLS.set(keyName, value);
    } catch (err) {
      console.error('ERROR: LocalStorage encryption:', err);
      window.localStorage.removeItem(keyName);
    }
  };

  const [storedValue, setStoredValue] = useState(() => {
    try {
      const encryptedValue = window.localStorage.getItem(keyName);
      
      if (!encryptedValue) {
        setEncryptedValue(defaultValue);
        return defaultValue;
      }

      // Get the decrypted value directly
      const decryptedValue = secureLS.get(keyName);
      
      if (decryptedValue === undefined || decryptedValue === null) {
        console.warn('No decrypted value found, using default');
        setEncryptedValue(defaultValue);
        return defaultValue;
      }

      // Return the decrypted value directly since secureLS handles the parsing
      return decryptedValue;
    } catch (err) {
      console.error('ERROR: LocalStorage decryption:', err);
      window.localStorage.removeItem(keyName);
      setEncryptedValue(defaultValue);
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    try {
      setEncryptedValue(newValue);
      setStoredValue(newValue);
    } catch (err) {
      console.error('ERROR: Setting new value:', err);
    }
  };

  return [storedValue, setValue];
};
